var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"sg-header-nav"},[_c('a',{ref:"hamburger",staticClass:"sg-header-nav__hamburger",attrs:{"title":"Menü öffnen/schließen","aria-hidden":"true","tabindex":"-1"},on:{"click":_vm.clicked,"blur":_vm.blurred}},[_c('icon',{attrs:{"fa":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"sg-header-nav__wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }